import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyCpLhBjI2qAwQ6zDWdLXRcR2WqVbOG3kug",
  authDomain: "mini-monstars-au.firebaseapp.com",
  projectId: "mini-monstars-au",
  storageBucket: "mini-monstars-au.appspot.com",
  messagingSenderId: "1020303504267",
  appId: "1:1020303504267:web:9d7417231c76b0f351b58e",
  measurementId: "G-TWTKQQ8G26"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)